var map = {
	"./img/animations/storyboard-menu-creation.gif": "5e8d",
	"./img/animations/storyboard-menu-creation.webp": "9d01",
	"./img/applications/confetti.png": "951e",
	"./img/applications/eye-infinite-player.png": "2fc1",
	"./img/applications/eye-inspire.png": "3d6c",
	"./img/applications/eye-intelligence.png": "6c08",
	"./img/applications/food-force.png": "156f",
	"./img/applications/only1-generation.png": "5839",
	"./img/applications/reserve-shop.png": "e880",
	"./img/applications/storyboard-infinite.png": "87e5",
	"./img/applications/storyboard-lite.png": "f3c4",
	"./img/applications/storyboard-pro.png": "a013",
	"./img/applications/wifi-login.png": "f42a",
	"./img/backgrounds/abstract.jpg": "e52e",
	"./img/backgrounds/abstract.webp": "4f1b",
	"./img/backgrounds/bus-passengers.jpg": "800b",
	"./img/backgrounds/bus-passengers.webp": "8998",
	"./img/backgrounds/business.jpg": "9374",
	"./img/backgrounds/business.webp": "7a13",
	"./img/backgrounds/clients.jpg": "e782",
	"./img/backgrounds/clients.webp": "2a38",
	"./img/backgrounds/contact-tracing.jpg": "fde7",
	"./img/backgrounds/design-team.jpg": "b860",
	"./img/backgrounds/design-team.webp": "90a5",
	"./img/backgrounds/digital-signage-installation.jpg": "c12d",
	"./img/backgrounds/digital-signage-installation.webp": "2be8",
	"./img/backgrounds/digital-signage.jpg": "66d2",
	"./img/backgrounds/digital-signage.webp": "e2b6",
	"./img/backgrounds/education.jpg": "30e8",
	"./img/backgrounds/education.webp": "253d",
	"./img/backgrounds/eye-in-office.jpg": "8295",
	"./img/backgrounds/eye-in-office.webp": "6a10",
	"./img/backgrounds/eye-in-welcome-2.jpg": "049f",
	"./img/backgrounds/eye-in-welcome-2.webp": "acc2",
	"./img/backgrounds/eye-in-welcome.jpg": "5bc3",
	"./img/backgrounds/eye-in-welcome.webp": "098b",
	"./img/backgrounds/eye-infinite-player.jpg": "36c4",
	"./img/backgrounds/eye-infinite-player.webp": "e991",
	"./img/backgrounds/features.jpg": "8eac",
	"./img/backgrounds/features.webp": "33fb",
	"./img/backgrounds/food-force-background.jpg": "b4ff",
	"./img/backgrounds/food-force-background.webp": "d989",
	"./img/backgrounds/gdpr.jpg": "d046",
	"./img/backgrounds/gdpr.webp": "5bb6",
	"./img/backgrounds/healthcare-welcome-screen.jpg": "e167",
	"./img/backgrounds/healthcare.jpg": "34dc",
	"./img/backgrounds/markets.jpg": "85f1",
	"./img/backgrounds/markets.webp": "ca9f",
	"./img/backgrounds/menu-board-coq-frit.jpg": "3b5d",
	"./img/backgrounds/menu-board-coq-frit.webp": "fd69",
	"./img/backgrounds/menu-board-double-pizza.jpg": "8ebd",
	"./img/backgrounds/menu-board-double-pizza.webp": "5d28",
	"./img/backgrounds/menu-board-mc-donald.jpg": "dd54",
	"./img/backgrounds/menu-board-mc-donald.webp": "60a3",
	"./img/backgrounds/menu-board-thai-express-2.jpg": "828a",
	"./img/backgrounds/menu-board-thai-express-2.webp": "fe97",
	"./img/backgrounds/menu-board-thai-express.jpg": "343e",
	"./img/backgrounds/menu-board-thai-express.webp": "7743",
	"./img/backgrounds/menuboard.jpg": "13a5",
	"./img/backgrounds/menuboard.webp": "4149",
	"./img/backgrounds/planet-earth.jpg": "0e35",
	"./img/backgrounds/planet-earth.webp": "4b63",
	"./img/backgrounds/restaurant-above.jpg": "6d61",
	"./img/backgrounds/restaurant-above.webp": "00b9",
	"./img/backgrounds/restaurant-inside-2.jpg": "c890",
	"./img/backgrounds/restaurant-inside.jpg": "24de",
	"./img/backgrounds/restauration-kitchen.jpg": "87fc",
	"./img/backgrounds/restauration-kitchen.webp": "5ab6",
	"./img/backgrounds/services-2.jpg": "0fbd",
	"./img/backgrounds/services-2.webp": "4d86",
	"./img/backgrounds/services.jpg": "b9e7",
	"./img/backgrounds/services.webp": "727d",
	"./img/backgrounds/shopping-mall-2.jpg": "9b55",
	"./img/backgrounds/shopping-mall-2.webp": "dc77",
	"./img/backgrounds/shopping-retail.jpg": "bdac",
	"./img/backgrounds/shopping-retail.webp": "f951",
	"./img/backgrounds/storyboard.jpg": "e839",
	"./img/backgrounds/storyboard.webp": "f8de",
	"./img/backgrounds/technology-2.jpg": "993a",
	"./img/backgrounds/technology-2.webp": "4514",
	"./img/backgrounds/technology.jpg": "31ba",
	"./img/backgrounds/technology.webp": "fe29",
	"./img/backgrounds/tizen-desktop.jpg": "041c",
	"./img/backgrounds/tizen-desktop.webp": "d005",
	"./img/backgrounds/tizen-light.jpg": "c201",
	"./img/backgrounds/tizen-mobile.jpg": "a7c2",
	"./img/backgrounds/tizen-mobile.webp": "0a59",
	"./img/backgrounds/transportation-blue.jpg": "ace6",
	"./img/backgrounds/transportation-blue.webp": "edbf",
	"./img/backgrounds/transportation.jpg": "57b9",
	"./img/backgrounds/videowall.jpg": "99a7",
	"./img/backgrounds/videowall.webp": "048f",
	"./img/branding/eye_in_wireless_en_white.png": "a6fe",
	"./img/branding/eye_in_wireless_en_white.webp": "8622",
	"./img/branding/eye_in_wireless_fr_white.png": "b6d8",
	"./img/branding/eye_in_wireless_fr_white.webp": "0827",
	"./img/branding/logo-20-years-white-sm.png": "c5b2",
	"./img/branding/logo-20-years-white.png": "2223",
	"./img/branding/logo-inline-white-sm.png": "fef3",
	"./img/branding/logo-inline-white-sm.webp": "b7e2",
	"./img/branding/logo-inline-white.png": "a095",
	"./img/branding/logo-inline-white.webp": "7919",
	"./img/branding/logo-inline.png": "f8d1",
	"./img/branding/logo-inline.webp": "a1a3",
	"./img/branding/logo-white.png": "711b",
	"./img/branding/logo-white.webp": "86e3",
	"./img/branding/logo.png": "d087",
	"./img/branding/logo.webp": "ff77",
	"./img/clients-color/banks/mouvement_desjardins.png": "8afb",
	"./img/clients-color/banks/mouvement_desjardins.webp": "353b",
	"./img/clients-color/education/cegep-garneau.png": "fefb",
	"./img/clients-color/education/cegep-garneau.webp": "7842",
	"./img/clients-color/education/cegep-outaouais.jpg": "eee3",
	"./img/clients-color/education/cegep-outaouais.webp": "1c82",
	"./img/clients-color/education/cegep-sorel-tracy.png": "11731",
	"./img/clients-color/education/cegep-sorel-tracy.webp": "1fdd",
	"./img/clients-color/education/cegep_beauce_appalache.png": "ff85",
	"./img/clients-color/education/cegep_beauce_appalache.webp": "bd49",
	"./img/clients-color/education/champlain_college.png": "2814",
	"./img/clients-color/education/champlain_college.webp": "0e6d",
	"./img/clients-color/education/college-alma.jpg": "e626",
	"./img/clients-color/education/college-alma.webp": "c049",
	"./img/clients-color/education/ecole-cfpo.png": "28e5",
	"./img/clients-color/education/ecole-cfpo.webp": "68e5",
	"./img/clients-color/education/ecole-maimonides.png": "6040",
	"./img/clients-color/education/ecole-maimonides.webp": "9363",
	"./img/clients-color/education/ecole-mont-bleu.jpg": "91dd",
	"./img/clients-color/education/ecole-mont-bleu.webp": "dbd1",
	"./img/clients-color/education/portage-outaouais.png": "9006",
	"./img/clients-color/education/portage-outaouais.webp": "c2b8",
	"./img/clients-color/education/simon-fraser-university.png": "1eff",
	"./img/clients-color/education/simon-fraser-university.webp": "61b6",
	"./img/clients-color/entertainment/amphiteatre-cogeco.png": "4f8e",
	"./img/clients-color/entertainment/amphiteatre-cogeco.webp": "042a",
	"./img/clients-color/entertainment/clip-n-climb.png": "b154",
	"./img/clients-color/entertainment/clip-n-climb.webp": "128d",
	"./img/clients-color/entertainment/complexe-sportif-claude-robillard.png": "8064",
	"./img/clients-color/entertainment/complexe-sportif-claude-robillard.webp": "98f9",
	"./img/clients-color/entertainment/musee-grevin.png": "934e",
	"./img/clients-color/entertainment/musee-grevin.webp": "7115",
	"./img/clients-color/entertainment/parc-drummondville.png": "eb50",
	"./img/clients-color/entertainment/parc-drummondville.webp": "d81a",
	"./img/clients-color/entertainment/place-des-arts.png": "fb56",
	"./img/clients-color/entertainment/place-des-arts.webp": "0a49",
	"./img/clients-color/healthcare/aesthetic_medical_clinic.png": "df6d",
	"./img/clients-color/healthcare/aesthetic_medical_clinic.webp": "0c39",
	"./img/clients-color/healthcare/centre-services-scolaire-patriotes.png": "5441",
	"./img/clients-color/healthcare/centre-services-scolaire-patriotes.webp": "a2e2",
	"./img/clients-color/healthcare/chsld.png": "f92c",
	"./img/clients-color/healthcare/chsld.webp": "3fac",
	"./img/clients-color/healthcare/ciusss.png": "532b",
	"./img/clients-color/healthcare/ciusss.webp": "3d9e",
	"./img/clients-color/healthcare/client_shriners.jpg": "7bf3",
	"./img/clients-color/healthcare/client_shriners.webp": "7df1",
	"./img/clients-color/healthcare/clinique_ovo.png": "0887",
	"./img/clients-color/healthcare/clinique_ovo.webp": "4b39",
	"./img/clients-color/healthcare/csss_bordeaux.png": "c1b6",
	"./img/clients-color/healthcare/csss_bordeaux.webp": "f8f3",
	"./img/clients-color/healthcare/csss_la_montagne.png": "f4ec",
	"./img/clients-color/healthcare/csss_la_montagne.webp": "465c",
	"./img/clients-color/healthcare/fondation-mathieu-froment-savoie.png": "078d",
	"./img/clients-color/healthcare/fondation-mathieu-froment-savoie.webp": "76e2",
	"./img/clients-color/healthcare/fondation_sante_gatineau.png": "9bec",
	"./img/clients-color/healthcare/fondation_sante_gatineau.webp": "52e0",
	"./img/clients-color/healthcare/hopital-montfort.png": "7e36",
	"./img/clients-color/healthcare/hopital-montfort.webp": "c90c",
	"./img/clients-color/healthcare/hopital-sacre-coeur.png": "3b78",
	"./img/clients-color/healthcare/hopital-sacre-coeur.webp": "60d1",
	"./img/clients-color/healthcare/hopital_chinois.png": "54fa",
	"./img/clients-color/healthcare/hopital_chinois.webp": "3ea7",
	"./img/clients-color/healthcare/hopital_enseignement_juif.png": "7808",
	"./img/clients-color/healthcare/hopital_enseignement_juif.webp": "d9c0",
	"./img/clients-color/healthcare/hopital_general_juif.png": "ae33",
	"./img/clients-color/healthcare/hopital_general_juif.webp": "c53b",
	"./img/clients-color/healthcare/institut-douglas.png": "f713",
	"./img/clients-color/healthcare/institut-physimed.png": "2e3c",
	"./img/clients-color/healthcare/institut-physimed.webp": "df1f",
	"./img/clients-color/healthcare/institut_philippe_pinel.png": "4635",
	"./img/clients-color/healthcare/institut_philippe_pinel.webp": "8d92",
	"./img/clients-color/healthcare/maimonides-transparent.png": "0fa6",
	"./img/clients-color/healthcare/maimonides.png": "76d2",
	"./img/clients-color/healthcare/maimonides.webp": "d742",
	"./img/clients-color/healthcare/maison-collines.png": "51f4",
	"./img/clients-color/healthcare/maison-collines.webp": "a8d3",
	"./img/clients-color/healthcare/miriam.png": "268f",
	"./img/clients-color/healthcare/miriam.webp": "2adf",
	"./img/clients-color/manufacturer/life-science-nutritional.jpg": "7615",
	"./img/clients-color/manufacturer/life-science-nutritional.png": "aaed",
	"./img/clients-color/municipalities/bois_des_filion.png": "1a1b",
	"./img/clients-color/municipalities/bois_des_filion.webp": "cbb6",
	"./img/clients-color/municipalities/cote_st_luc.png": "6495",
	"./img/clients-color/municipalities/cote_st_luc.webp": "d793",
	"./img/clients-color/municipalities/gatineau.png": "1548",
	"./img/clients-color/municipalities/gatineau.webp": "a30c",
	"./img/clients-color/municipalities/montreal ex.png": "3dde",
	"./img/clients-color/municipalities/montreal ex.webp": "3ed4",
	"./img/clients-color/municipalities/montreal.png": "7991",
	"./img/clients-color/municipalities/montreal.webp": "9081",
	"./img/clients-color/municipalities/ville-bromont.png": "20e6",
	"./img/clients-color/municipalities/ville-bromont.webp": "fdba",
	"./img/clients-color/municipalities/ville-drummondville.png": "a27a",
	"./img/clients-color/municipalities/ville-drummondville.webp": "013b",
	"./img/clients-color/municipalities/ville-terrebonne.png": "735e",
	"./img/clients-color/municipalities/westmount.png": "c503",
	"./img/clients-color/municipalities/westmount.webp": "02fe",
	"./img/clients-color/real-estate/bental-kennedy.png": "1a3a",
	"./img/clients-color/real-estate/bental-kennedy.webp": "86eb",
	"./img/clients-color/real-estate/carjen_property_management.png": "8a85",
	"./img/clients-color/real-estate/carjen_property_management.webp": "c4ed",
	"./img/clients-color/real-estate/cogir.png": "29ab",
	"./img/clients-color/real-estate/cogir.webp": "66d0",
	"./img/clients-color/real-estate/cominar.png": "5b91",
	"./img/clients-color/real-estate/cominar.webp": "e799",
	"./img/clients-color/real-estate/cushman-wakefield.png": "a5b9",
	"./img/clients-color/real-estate/cushman-wakefield.webp": "d6ea",
	"./img/clients-color/real-estate/desjardins_carrefour.png": "2861",
	"./img/clients-color/real-estate/desjardins_carrefour.webp": "2509",
	"./img/clients-color/real-estate/desjardins_complexe.png": "b05b",
	"./img/clients-color/real-estate/desjardins_complexe.webp": "e6be",
	"./img/clients-color/real-estate/desjardins_immobilier.png": "dc67",
	"./img/clients-color/real-estate/desjardins_immobilier.webp": "e22e",
	"./img/clients-color/real-estate/ivanhoe_cambridge.png": "5b4eb",
	"./img/clients-color/real-estate/ivanhoe_cambridge.webp": "8170",
	"./img/clients-color/real-estate/morguard.png": "5b9e",
	"./img/clients-color/real-estate/morguard.webp": "01de",
	"./img/clients-color/real-estate/oxford.png": "b886",
	"./img/clients-color/real-estate/oxford.webp": "7016",
	"./img/clients-color/real-estate/porto-bellagio-condos.jpg": "2808",
	"./img/clients-color/real-estate/westcliff.png": "ebfc",
	"./img/clients-color/real-estate/westcliff.webp": "c73a",
	"./img/clients-color/restauration/am-pm-kosher-market.png": "606e",
	"./img/clients-color/restauration/amis-montagne.png": "1ed9",
	"./img/clients-color/restauration/arouch.png": "ae31",
	"./img/clients-color/restauration/arouch.webp": "8250",
	"./img/clients-color/restauration/cafe_depot.png": "c124",
	"./img/clients-color/restauration/cafe_depot.webp": "6130",
	"./img/clients-color/restauration/client_coq_frit.jpg": "ea8d",
	"./img/clients-color/restauration/client_coq_frit.webp": "db40",
	"./img/clients-color/restauration/double_pizza.png": "02b2",
	"./img/clients-color/restauration/double_pizza.webp": "12aa",
	"./img/clients-color/restauration/dunkin_donut.png": "b1be",
	"./img/clients-color/restauration/dunkin_donut.webp": "5602",
	"./img/clients-color/restauration/koryo.png": "100b",
	"./img/clients-color/restauration/koryo.webp": "1ada",
	"./img/clients-color/restauration/mc_cafe.png": "056f",
	"./img/clients-color/restauration/mc_cafe.webp": "ec0d",
	"./img/clients-color/restauration/mc_donalds.jpg": "8df3",
	"./img/clients-color/restauration/mc_donalds.webp": "c40d",
	"./img/clients-color/restauration/mty-cultures.png": "cc8e",
	"./img/clients-color/restauration/mty.png": "e2c7",
	"./img/clients-color/restauration/mty.webp": "7ea3",
	"./img/clients-color/restauration/old_mc_donald.png": "b140",
	"./img/clients-color/restauration/old_mc_donald.webp": "445e",
	"./img/clients-color/restauration/presse_cafe.png": "9bab",
	"./img/clients-color/restauration/presse_cafe.webp": "7fff",
	"./img/clients-color/restauration/roaster.png": "8561",
	"./img/clients-color/restauration/roaster.webp": "d52f",
	"./img/clients-color/restauration/second-cup.png": "f9cf",
	"./img/clients-color/restauration/second-cup.webp": "740d",
	"./img/clients-color/restauration/solit-cafe.png": "9640",
	"./img/clients-color/restauration/subway.png": "8e18",
	"./img/clients-color/restauration/subway.webp": "4772",
	"./img/clients-color/restauration/tcby.png": "a241",
	"./img/clients-color/restauration/tcby.webp": "fc4d",
	"./img/clients-color/restauration/thai_express.png": "5d6e",
	"./img/clients-color/restauration/thai_express.webp": "fb91",
	"./img/clients-color/restauration/van_houtte.png": "754c",
	"./img/clients-color/restauration/van_houtte.webp": "60bb",
	"./img/clients-color/restauration/villa_madina.png": "dfe8",
	"./img/clients-color/restauration/villa_madina.webp": "25c0",
	"./img/clients-color/restauration/voie-maltee-quebec.png": "2894",
	"./img/clients-color/restauration/voie-maltee-quebec.webp": "0894",
	"./img/clients-color/retail/couche_tard.png": "98ba",
	"./img/clients-color/retail/couche_tard.webp": "fb88",
	"./img/clients-color/retail/decathlon-canada.png": "f6d2",
	"./img/clients-color/retail/decathlon-canada.webp": "653a",
	"./img/clients-color/retail/kim-phat.png": "f9c5",
	"./img/clients-color/retail/loreal_canada.png": "5836",
	"./img/clients-color/retail/loreal_canada.webp": "3cc4",
	"./img/clients-color/retail/nedco.png": "efa3",
	"./img/clients-color/retail/nedco.webp": "5ff6",
	"./img/clients-color/shopping-center/alexis_nihon.png": "36c1",
	"./img/clients-color/shopping-center/alexis_nihon.webp": "d087a",
	"./img/clients-color/shopping-center/bayshore.png": "fd55",
	"./img/clients-color/shopping-center/bayshore.webp": "ebab",
	"./img/clients-color/shopping-center/carrefour-estrie.png": "b88c",
	"./img/clients-color/shopping-center/carrefour-estrie.svg": "d535",
	"./img/clients-color/shopping-center/carrefour_angrignon.png": "0b19",
	"./img/clients-color/shopping-center/carrefour_angrignon.webp": "711c",
	"./img/clients-color/shopping-center/carrefour_frontenac.png": "7dbb",
	"./img/clients-color/shopping-center/carrefour_frontenac.webp": "c940",
	"./img/clients-color/shopping-center/carrefour_nord.png": "b578",
	"./img/clients-color/shopping-center/carrefour_nord.webp": "81be",
	"./img/clients-color/shopping-center/carrefour_rimouski.png": "4183",
	"./img/clients-color/shopping-center/carrefour_rimouski.webp": "8bff",
	"./img/clients-color/shopping-center/centre-boulevard.jpg": "bc3f",
	"./img/clients-color/shopping-center/centre-boulevard.webp": "a842",
	"./img/clients-color/shopping-center/centre_eaton.png": "e5c8",
	"./img/clients-color/shopping-center/centre_eaton.webp": "8728",
	"./img/clients-color/shopping-center/centre_laval.png": "3329",
	"./img/clients-color/shopping-center/centre_laval.webp": "250a",
	"./img/clients-color/shopping-center/centres_rivieres.png": "31b9",
	"./img/clients-color/shopping-center/centres_rivieres.webp": "17a2",
	"./img/clients-color/shopping-center/centropolis.png": "1b93",
	"./img/clients-color/shopping-center/centropolis.webp": "1639",
	"./img/clients-color/shopping-center/complexe_desjardins.png": "d2f7",
	"./img/clients-color/shopping-center/complexe_desjardins.webp": "a082",
	"./img/clients-color/shopping-center/complexe_les_ailes.png": "5ed9",
	"./img/clients-color/shopping-center/complexe_les_ailes.webp": "cc30",
	"./img/clients-color/shopping-center/galerie-rive-nord.svg": "fdd5",
	"./img/clients-color/shopping-center/galeries-rive-nord.png": "1cf0",
	"./img/clients-color/shopping-center/galeries_chagnon.png": "e213",
	"./img/clients-color/shopping-center/galeries_chagnon.webp": "42c2",
	"./img/clients-color/shopping-center/mail_montenach.png": "891a",
	"./img/clients-color/shopping-center/mail_montenach.webp": "eb4f",
	"./img/clients-color/shopping-center/new-sudbury-centre.png": "2785",
	"./img/clients-color/shopping-center/new-sudbury-centre.webp": "9301",
	"./img/clients-color/shopping-center/place-de-la-cite.png": "8aa8",
	"./img/clients-color/shopping-center/place-de-la-cite.svg": "e7f0",
	"./img/clients-color/shopping-center/place-rosemere.png": "1684",
	"./img/clients-color/shopping-center/place-rosemere.webp": "23ce",
	"./img/clients-color/shopping-center/place_centre.png": "e794",
	"./img/clients-color/shopping-center/place_centre.webp": "c946",
	"./img/clients-color/shopping-center/place_centre_bw.png": "cb4e",
	"./img/clients-color/shopping-center/place_centre_bw.webp": "9880",
	"./img/clients-color/shopping-center/place_longueuil.png": "1be7",
	"./img/clients-color/shopping-center/place_longueuil.webp": "4fd2",
	"./img/clients-color/shopping-center/place_vertu.png": "d327",
	"./img/clients-color/shopping-center/place_vertu.webp": "4695",
	"./img/clients-color/shopping-center/promenade_cathedrale.png": "a087",
	"./img/clients-color/shopping-center/promenade_cathedrale.webp": "436b",
	"./img/clients-color/shopping-center/westmount_square.png": "ddd1",
	"./img/clients-color/shopping-center/westmount_square.webp": "4be4",
	"./img/clients-color/transportation/autobus-breton.png": "e638",
	"./img/clients-color/transportation/autobus-breton.webp": "61fb",
	"./img/clients-color/transportation/autobus-galland.png": "2fc8",
	"./img/clients-color/transportation/autobus-galland.webp": "3dc4",
	"./img/clients-color/transportation/autocar_preferences.png": "92c4",
	"./img/clients-color/transportation/autocar_preferences.webp": "05da",
	"./img/clients-color/transportation/bell-horizon.png": "72b9",
	"./img/clients-color/transportation/bell-horizon.webp": "ff9a",
	"./img/clients-color/transportation/blus.png": "6d59",
	"./img/clients-color/transportation/blus.webp": "0dae",
	"./img/clients-color/transportation/fleur_lys.png": "aa40",
	"./img/clients-color/transportation/fleur_lys.webp": "4e41",
	"./img/clients-color/transportation/foley-bus-lines.png": "8482",
	"./img/clients-color/transportation/foley-bus-lines.webp": "5deb",
	"./img/clients-color/transportation/king_charters.png": "278c",
	"./img/clients-color/transportation/king_charters.webp": "0426",
	"./img/clients-color/transportation/king_tours.png": "462d",
	"./img/clients-color/transportation/king_tours.webp": "5eb0",
	"./img/clients-color/transportation/leduc.png": "8d5e",
	"./img/clients-color/transportation/leduc.webp": "af18",
	"./img/clients-color/transportation/limocar.png": "0d33",
	"./img/clients-color/transportation/limocar.webp": "9835",
	"./img/clients-color/transportation/magic-bus-company.png": "280e",
	"./img/clients-color/transportation/magic-bus-company.webp": "90c0",
	"./img/clients-color/transportation/quick_coach_shuttle.png": "6678",
	"./img/clients-color/transportation/quick_coach_shuttle.webp": "7078",
	"./img/clients-color/transportation/rider-express.png": "2417",
	"./img/clients-color/transportation/rider-express.webp": "50d4",
	"./img/clients-color/transportation/silent-rides.png": "1187",
	"./img/clients-color/transportation/silent-rides.webp": "c44f",
	"./img/clients-color/transportation/south-sask-bus-lines.png": "5164",
	"./img/clients-color/transportation/south-sask-bus-lines.webp": "76e6",
	"./img/clients-color/transportation/stm.png": "be91",
	"./img/clients-color/transportation/stm.webp": "9a79",
	"./img/clients-color/transportation/transdev.png": "fb86",
	"./img/clients-color/transportation/transdev.webp": "3f6b",
	"./img/clients-color/transportation/vbl.png": "649f",
	"./img/clients-color/transportation/vbl.webp": "f716",
	"./img/clients-color/transportation/veolia.png": "6a74",
	"./img/clients-color/transportation/veolia.webp": "309e",
	"./img/clients-white/alexis-nihon.png": "c93b",
	"./img/clients-white/alexis-nihon.webp": "3eb3",
	"./img/clients-white/carrefour-estrie.png": "49ea",
	"./img/clients-white/cegep-beauce-appalache.png": "7485",
	"./img/clients-white/cegep-beauce-appalache.svg": "eed8",
	"./img/clients-white/cegep-beauce-appalache.webp": "efa2",
	"./img/clients-white/cegep_beauce_appalache.png": "9c58",
	"./img/clients-white/cegep_beauce_appalache.webp": "1ca8",
	"./img/clients-white/client-place-des-arts.png": "db9f",
	"./img/clients-white/client-place-des-arts.webp": "e7d4",
	"./img/clients-white/clinique-ovo.png": "2b6e",
	"./img/clients-white/clip-climb.png": "d356",
	"./img/clients-white/clip-climb.webp": "63b2",
	"./img/clients-white/cominar.png": "106c",
	"./img/clients-white/cominar.webp": "c281",
	"./img/clients-white/csss-bordeau.png": "04cb",
	"./img/clients-white/cultures.png": "3401",
	"./img/clients-white/desjardins.png": "8ab2",
	"./img/clients-white/desjardins.webp": "8fa0",
	"./img/clients-white/eye-in-client-king-charters.png": "fcbc",
	"./img/clients-white/eye-in-client-king-charters.webp": "bace",
	"./img/clients-white/eye-in-client-king-tours.png": "a127",
	"./img/clients-white/eye-in-client-king-tours.webp": "ccdd",
	"./img/clients-white/eye-in-client-leduc.png": "c013",
	"./img/clients-white/eye-in-client-leduc.webp": "b5f6",
	"./img/clients-white/eye-in-client-limocar.png": "e6bc",
	"./img/clients-white/eye-in-client-limocar.webp": "f447",
	"./img/clients-white/galerie-rive-nord.png": "d4d2",
	"./img/clients-white/grevin_montreal.png": "6c4d",
	"./img/clients-white/grevin_montreal.webp": "e44e",
	"./img/clients-white/hopital-general-juif old.png": "e057",
	"./img/clients-white/hopital-general-juif.png": "5ed4",
	"./img/clients-white/hopital-montfort.png": "0095",
	"./img/clients-white/hopital-montfort.webp": "5ede",
	"./img/clients-white/institut-douglas.png": "734a",
	"./img/clients-white/institut-physimed.png": "881f",
	"./img/clients-white/koryo.png": "1ac4",
	"./img/clients-white/logo_jewish_hospital_fondation.png": "ea83",
	"./img/clients-white/maimonides.png": "675f",
	"./img/clients-white/mc_cafe.png": "cecb",
	"./img/clients-white/mc_cafe.webp": "a8b8",
	"./img/clients-white/mc_donald.png": "10db",
	"./img/clients-white/mc_donald.webp": "5bac",
	"./img/clients-white/mty.png": "b6cf",
	"./img/clients-white/mty.webp": "f1e4",
	"./img/clients-white/oreal_canada.png": "6b4c3",
	"./img/clients-white/oreal_canada.webp": "fafa",
	"./img/clients-white/ottawa_university.png": "ffb9",
	"./img/clients-white/ottawa_university.webp": "4566",
	"./img/clients-white/place-de-la-cite.png": "0654",
	"./img/clients-white/place_rosemere.png": "a814",
	"./img/clients-white/place_rosemere.webp": "205a",
	"./img/clients-white/shriners.png": "7bd4",
	"./img/clients-white/shriners.webp": "24ee",
	"./img/clients-white/simon-fraser-university.png": "0ba7",
	"./img/clients-white/simon-fraser-university.webp": "1e5d",
	"./img/clients-white/stm.png": "61a8",
	"./img/clients-white/stm.webp": "731f",
	"./img/clients-white/tcby.png": "09ee",
	"./img/clients-white/thai-express.png": "5e7d",
	"./img/clients-white/transdev.png": "b832",
	"./img/clients-white/transdev.webp": "679a",
	"./img/clients-white/westcliff.png": "4070",
	"./img/clients-white/westcliff.webp": "3374",
	"./img/ebook/ebook-shopping-mall-bg.jpg": "fc4e",
	"./img/ebook/ebook-shopping-mall-bg.webp": "b476",
	"./img/ebook/ebook-shopping-mall-cover.jpg": "3fd4",
	"./img/ebook/ebook-shopping-mall-cover.webp": "771f",
	"./img/examples/bus-transports.jpg": "3271",
	"./img/examples/bus-transports.webp": "f571",
	"./img/examples/clip-climb.jpg": "55f7",
	"./img/examples/clip-climb.webp": "6919",
	"./img/examples/corporate-office.jpg": "39a2",
	"./img/examples/corporate-office.webp": "1e44",
	"./img/examples/example-videowall-weekly-menu.png": "987b",
	"./img/examples/guest-wifi.jpg": "c364",
	"./img/examples/guest-wifi.webp": "b7a4",
	"./img/examples/holograms-1.jpg": "e1c6",
	"./img/examples/holograms-2.jpg": "96c6",
	"./img/examples/holograms-2.webp": "2d6f",
	"./img/examples/holograms.jpg": "ff8e",
	"./img/examples/holograms.webp": "8bea",
	"./img/examples/hypervsn-wall.jpg": "53c7",
	"./img/examples/info-kiosk.jpg": "322a",
	"./img/examples/info-kiosk.webp": "e678",
	"./img/examples/kiosk-carrefour-estrie-home.jpg": "fc37",
	"./img/examples/kiosk-carrefour-estrie-home.webp": "ac18",
	"./img/examples/kiosk-carrefour-estrie-search.jpg": "599d",
	"./img/examples/kiosk-carrefour-estrie-search.webp": "cc54",
	"./img/examples/kiosk-inventory-shopping-mall.jpg": "a7b4",
	"./img/examples/kiosk-inventory-shopping-mall.webp": "1d71",
	"./img/examples/kiosk-mach-map.jpg": "4abd",
	"./img/examples/kiosk-mach-map.webp": "7af3",
	"./img/examples/kiosk-place-de-la-cite-home.jpg": "1123",
	"./img/examples/kiosk-place-de-la-cite-home.webp": "7635",
	"./img/examples/kiosk-place-de-la-cite-map.jpg": "1405",
	"./img/examples/kiosk-place-de-la-cite-map.webp": "4f05",
	"./img/examples/menu-avril.jpg": "d491",
	"./img/examples/menu-avril.webp": "f4fc",
	"./img/examples/menu-cho-express.jpg": "2752",
	"./img/examples/menu-cho-express.webp": "c8a2",
	"./img/examples/menu-hopital-shriners.jpg": "2f01",
	"./img/examples/menu-hopital-shriners.webp": "7246",
	"./img/examples/menu-tcby.jpg": "7c62",
	"./img/examples/menu-tcby.webp": "0328",
	"./img/examples/menu-thai-express-complete.jpg": "683a",
	"./img/examples/menu-thai-express-complete.webp": "4652",
	"./img/examples/menu-thai-express.jpg": "b98d",
	"./img/examples/menu-thai-express.webp": "5ad2",
	"./img/examples/menuboard_mc_cafe.png": "8bb7",
	"./img/examples/menuboard_mc_cafe.webp": "c719",
	"./img/examples/menuboard_mc_cafe_alt.png": "ebc2",
	"./img/examples/menuboard_mc_cafe_alt.webp": "aac2",
	"./img/examples/menuboard_mc_cafe_large.png": "0bfbd",
	"./img/examples/menuboard_mc_cafe_large.webp": "774d",
	"./img/examples/menuboard_mc_cafe_large_alt.png": "94e8",
	"./img/examples/menuboard_mc_cafe_large_alt.webp": "ebaf",
	"./img/examples/menuboard_teryiaki.jpg": "9287",
	"./img/examples/menuboard_teryiaki_alt.jpg": "988f",
	"./img/examples/menuboard_teryiaki_large.png": "8fea",
	"./img/examples/menuboard_thai_express.jpg": "16b9",
	"./img/examples/menuboard_thai_express.webp": "acdc",
	"./img/examples/menuboard_thai_express_large.jpg": "e8809",
	"./img/examples/menuboard_thai_express_large.webp": "9055",
	"./img/examples/montreal-city-bus-wifi.jpg": "4823",
	"./img/examples/montreal-city-bus-wifi.webp": "1109",
	"./img/examples/shopper.jpg": "37d2",
	"./img/examples/shopper.webp": "baf0",
	"./img/examples/thai-express-menu.jpg": "1090",
	"./img/examples/thai-express-menu.webp": "c4a1",
	"./img/examples/videowall-oreal-2.jpg": "4179",
	"./img/examples/videowall-oreal.jpg": "0797",
	"./img/examples/videowall-oreal.webp": "8a04",
	"./img/examples/videowall.jpg": "1998",
	"./img/examples/videowall.webp": "e7de",
	"./img/examples/videowall_alt.jpg": "2759",
	"./img/examples/videowall_alt.webp": "288c",
	"./img/examples/videowall_large.jpg": "2847",
	"./img/examples/videowall_large.webp": "d952",
	"./img/examples/waiting-room.jpg": "0f41",
	"./img/examples/waiting-room.webp": "6f05",
	"./img/examples/wifi-shopping-mall.jpg": "d954",
	"./img/examples/wifi-shopping-mall.webp": "c538",
	"./img/features/analytics.png": "b9ff",
	"./img/features/cabling.jpg": "ef6f",
	"./img/features/cabling.webp": "7e05",
	"./img/features/cafeteria-menu-template-editable.jpg": "0dce",
	"./img/features/cafeteria-menu-template-editable.webp": "e85a",
	"./img/features/chat.png": "895b",
	"./img/features/client-happy-with-smart-wifi.jpg": "04ab",
	"./img/features/communication.png": "688f",
	"./img/features/compatible-mev-srm-revenu-quebec.jpg": "2aa7",
	"./img/features/configuration.jpg": "0f3f",
	"./img/features/configuration.webp": "6e46",
	"./img/features/contact-tracing-path.png": "5737",
	"./img/features/content-creation.jpg": "e8ed",
	"./img/features/content-creation.webp": "47f7",
	"./img/features/content-revision.jpg": "4fea",
	"./img/features/content-revision.webp": "0967",
	"./img/features/designer.jpg": "c61e",
	"./img/features/designer.webp": "afde",
	"./img/features/digital-signage.png": "f467",
	"./img/features/education-email-management.png": "a656",
	"./img/features/education-email-management.webp": "8e62",
	"./img/features/education-menu-cafeteria.png": "3876",
	"./img/features/education-menu-cafeteria.webp": "fba7",
	"./img/features/employee-of-the-month.jpg": "3546",
	"./img/features/employee-of-the-month.webp": "4309",
	"./img/features/example-contest-inscription-qr-code.png": "c012",
	"./img/features/example-contest-inscription-qr-code.webp": "1034",
	"./img/features/example-daily-menu-arrows.png": "42f2",
	"./img/features/example-daily-menu-arrows.webp": "ac11",
	"./img/features/example-dashboard-call-center-en.png": "cacb",
	"./img/features/example-dashboard-call-center-en.webp": "9724",
	"./img/features/example-digital-dashboard-kpi.png": "2e11",
	"./img/features/example-digital-dashboard-kpi.webp": "7783",
	"./img/features/example-education-zones.png": "c526",
	"./img/features/example-education-zones.webp": "335e",
	"./img/features/example-employee-month-arrows.png": "1fe9",
	"./img/features/example-employee-month-arrows.webp": "95a0",
	"./img/features/example-garage-kiosk-arrows.png": "7162",
	"./img/features/example-garage-kiosk-arrows.webp": "16cb",
	"./img/features/example-healthcare-zones.png": "3d65",
	"./img/features/example-healthcare-zones.webp": "d225c",
	"./img/features/example-interactive-kiosk-wayfinding.png": "4db9",
	"./img/features/example-interactive-kiosk-wayfinding.webp": "2a23",
	"./img/features/example-security-measures-arrows.png": "0586",
	"./img/features/example-security-measures-arrows.webp": "b08f",
	"./img/features/example-students-content-with-zones.png": "6a9f",
	"./img/features/example-students-content-with-zones.webp": "b24f",
	"./img/features/eye-in-wireless-compatible-wifi-6.png": "a18f",
	"./img/features/feature-cafeteria-videowall-menu.png": "4bab",
	"./img/features/feature-cafeteria-videowall-menu.webp": "524f",
	"./img/features/feature-healthcare-zones.png": "d744",
	"./img/features/feature-healthcare-zones.webp": "971b",
	"./img/features/feature-interactive-kiosks.png": "a5ef",
	"./img/features/feature-interactive-kiosks.webp": "e8c8",
	"./img/features/feature-upload-email-hospital.png": "17f2",
	"./img/features/feature-upload-email-hospital.webp": "4a08",
	"./img/features/feature-upload-email-school (2).webp": "ae70",
	"./img/features/feature-upload-email-school.png": "b866",
	"./img/features/feature-upload-email-school.webp": "3286",
	"./img/features/free-wifi-login-page.png": "bb55",
	"./img/features/free-wifi-login-page.webp": "cb85",
	"./img/features/geolocation.png": "14f2",
	"./img/features/guest-wifi.png": "9e19",
	"./img/features/healthcare-email-management.png": "bad3",
	"./img/features/healthcare-email-management.webp": "1b5c",
	"./img/features/healthcare-menu-cafeteria.png": "0959",
	"./img/features/healthcare-menu-cafeteria.webp": "5516",
	"./img/features/hologram-concept.jpg": "d32f",
	"./img/features/interactive-kiosks-portrait-landscape old.png": "88fc",
	"./img/features/interactive-kiosks-portrait-landscape old.webp": "3944",
	"./img/features/interactive-kiosks-portrait-landscape.png": "f5d8",
	"./img/features/interactive-kiosks-portrait-landscape.webp": "125b",
	"./img/features/kiosk-map-wayfinder-directory.png": "1909",
	"./img/features/kiosk-map-wayfinder-directory.webp": "ffdd",
	"./img/features/kiosk-map-wayfinder.jpg": "0bb9",
	"./img/features/kiosk-map-wayfinder.webp": "8ae0",
	"./img/features/kiosk-search-categories.png": "af53",
	"./img/features/kiosk-search-categories.webp": "9868",
	"./img/features/kiosk-specifications-en.png": "0805",
	"./img/features/kiosk-specifications-en.webp": "e219",
	"./img/features/kiosk-specifications-fr.png": "ee4d",
	"./img/features/kiosk-specifications-fr.webp": "8e7b",
	"./img/features/loyalty.png": "5c71",
	"./img/features/maps.png": "4a8d",
	"./img/features/pie-charts.png": "5c7b",
	"./img/features/player-configuration.jpg": "8add",
	"./img/features/player-configuration.png": "6c0b",
	"./img/features/qr-code-large.png": "0f27",
	"./img/features/restaurants-features-overview.png": "c45a",
	"./img/features/restaurants-features-overview.webp": "315a",
	"./img/features/security.png": "60cb",
	"./img/features/shopping-mall.jpg": "dcd2",
	"./img/features/shopping-mall.webp": "5b15",
	"./img/features/site-survey.jpg": "62aa",
	"./img/features/site-survey.webp": "18c6",
	"./img/features/support.jpg": "0b55",
	"./img/features/support.webp": "c407",
	"./img/features/tv-installation.jpg": "1b85",
	"./img/features/tv-installation.webp": "f84c",
	"./img/features/tv-simulation.jpg": "e9fc",
	"./img/features/tv-simulation.webp": "2983",
	"./img/features/wayfinder-main-features-fr.png": "b6f9",
	"./img/features/wayfinder-main-features-fr.webp": "e265",
	"./img/font-awesome/apple-brands.svg": "745f",
	"./img/font-awesome/facebook-brands.svg": "ac5d",
	"./img/font-awesome/linkedin-brands.svg": "31c1",
	"./img/font-awesome/linux-brands.svg": "40f2",
	"./img/font-awesome/twitter-brands.svg": "2d70",
	"./img/font-awesome/ubuntu-brands.svg": "f396",
	"./img/font-awesome/windows-brands.svg": "168c",
	"./img/font-awesome/youtube-brands.svg": "b93f",
	"./img/icon.png": "f0fc",
	"./img/icons/actress.png": "a122",
	"./img/icons/actress.webp": "7901",
	"./img/icons/ads.png": "9190",
	"./img/icons/ads.webp": "54c1",
	"./img/icons/airplane-ticket.png": "59b9",
	"./img/icons/airplane-ticket.webp": "fbf5",
	"./img/icons/analytics.png": "34eb",
	"./img/icons/analytics.webp": "cb2e",
	"./img/icons/app-pay.png": "85e7",
	"./img/icons/app-pay.webp": "c6f4",
	"./img/icons/app-table-number.png": "725e",
	"./img/icons/app-table-number.webp": "076a",
	"./img/icons/bank.png": "6c16",
	"./img/icons/bank.webp": "b459",
	"./img/icons/billboard.png": "5522",
	"./img/icons/billboard.webp": "123d",
	"./img/icons/bus-white.png": "7c1f",
	"./img/icons/bus-white.webp": "fbef",
	"./img/icons/bus.png": "9999",
	"./img/icons/bus.webp": "1569",
	"./img/icons/business.png": "9a32",
	"./img/icons/business.webp": "0ddd",
	"./img/icons/calendar-time.png": "b87a",
	"./img/icons/calendar-time.webp": "205d",
	"./img/icons/calendar.png": "c0b0",
	"./img/icons/calendar.svg": "557c",
	"./img/icons/calendar.webp": "cdf3",
	"./img/icons/call-center.png": "20a2",
	"./img/icons/call-center.webp": "8be7",
	"./img/icons/camera-2.svg": "f111",
	"./img/icons/camera.svg": "eae6",
	"./img/icons/chat-v2.png": "8b8c",
	"./img/icons/chat-v2.webp": "642e",
	"./img/icons/chat.png": "a02e",
	"./img/icons/chat.webp": "7a35",
	"./img/icons/checkin.svg": "de10",
	"./img/icons/circle-touch-screen.png": "de59",
	"./img/icons/clipboard (1).png": "1238",
	"./img/icons/clipboard (1).webp": "14ec",
	"./img/icons/clipboard (2).png": "bf9f",
	"./img/icons/clipboard (2).webp": "423d",
	"./img/icons/code.png": "28d3",
	"./img/icons/code.webp": "2944",
	"./img/icons/compatilibty-wifi-6.png": "ab9e",
	"./img/icons/compatilibty-wifi-6.webp": "0cd7",
	"./img/icons/complete-bilingual-solution.png": "f75a",
	"./img/icons/complete-bilingual-solution.webp": "f4ba7",
	"./img/icons/compliant-gdpr-en.png": "6b1c",
	"./img/icons/compliant-gdpr-fr.png": "94a3",
	"./img/icons/compliant-law-25-en.png": "6799",
	"./img/icons/compliant-law-25-fr.png": "e264",
	"./img/icons/computer.png": "c01a",
	"./img/icons/computer.webp": "add4",
	"./img/icons/content-filtering.png": "434a",
	"./img/icons/content-filtering.webp": "6415",
	"./img/icons/coupon-2.png": "3adf",
	"./img/icons/coupon-2.webp": "de8b",
	"./img/icons/coupon.png": "ea7c",
	"./img/icons/coupon.webp": "bf15",
	"./img/icons/dashboard.png": "e7f08",
	"./img/icons/dashboard.webp": "f8c1",
	"./img/icons/digital-marketing.png": "b3a3",
	"./img/icons/digital-marketing.webp": "9baa",
	"./img/icons/digital-menuboards.png": "7412",
	"./img/icons/digital-menuboards.webp": "305c",
	"./img/icons/dining-table.png": "5862",
	"./img/icons/dining-table.webp": "7a2d",
	"./img/icons/discount-ticket.png": "e9bb",
	"./img/icons/discount-ticket.webp": "4e12",
	"./img/icons/discount.svg": "38d6",
	"./img/icons/dress.png": "ac35",
	"./img/icons/dress.webp": "3a81",
	"./img/icons/education.png": "07ad",
	"./img/icons/education.webp": "f24d",
	"./img/icons/email.png": "87d1",
	"./img/icons/email.webp": "4d5a",
	"./img/icons/employee.svg": "8493",
	"./img/icons/feedback old.png": "d92d",
	"./img/icons/feedback old.webp": "a5ab",
	"./img/icons/feedback.png": "6c1e",
	"./img/icons/feedback.webp": "6fda",
	"./img/icons/files.png": "777f",
	"./img/icons/files.webp": "4dc8",
	"./img/icons/find-gadget.png": "d271",
	"./img/icons/find-gadget.webp": "0cce",
	"./img/icons/food-app.png": "a650",
	"./img/icons/food-app.webp": "5553",
	"./img/icons/food.png": "add8",
	"./img/icons/food.webp": "4f4a",
	"./img/icons/form.svg": "174e",
	"./img/icons/gate.png": "55db",
	"./img/icons/gate.webp": "d330",
	"./img/icons/gopro.png": "e4be",
	"./img/icons/gopro.webp": "0144",
	"./img/icons/gps-1.png": "b653",
	"./img/icons/gps-1.webp": "b131",
	"./img/icons/gps.png": "a4f2",
	"./img/icons/gps.webp": "e2d2",
	"./img/icons/group-chat.png": "4384",
	"./img/icons/group-chat.webp": "1e84",
	"./img/icons/guest-access-2.png": "3696",
	"./img/icons/guest-access-2.webp": "c88c",
	"./img/icons/guest-access-old.png": "181a",
	"./img/icons/guest-access-old.webp": "d916",
	"./img/icons/guest-access.png": "0864",
	"./img/icons/guest-access.webp": "f42a2",
	"./img/icons/hospital ex.png": "3381",
	"./img/icons/hospital ex.webp": "1e93",
	"./img/icons/hospital.png": "8d25",
	"./img/icons/hospital.webp": "c229",
	"./img/icons/hotel.png": "006c",
	"./img/icons/hotel.webp": "6e58",
	"./img/icons/hotspot-old.png": "1f5d",
	"./img/icons/hotspot-old.webp": "7a06",
	"./img/icons/hotspot.png": "8adc",
	"./img/icons/hotspot.webp": "0c07",
	"./img/icons/idea.png": "70e6",
	"./img/icons/idea.webp": "6ce2",
	"./img/icons/info.png": "8720",
	"./img/icons/info.webp": "bece",
	"./img/icons/internet.png": "a559",
	"./img/icons/internet.webp": "cece",
	"./img/icons/kitchen-display.png": "326b",
	"./img/icons/kitchen-display.webp": "06f6",
	"./img/icons/ladies.png": "92e3",
	"./img/icons/ladies.webp": "d713",
	"./img/icons/library.png": "8c56",
	"./img/icons/library.webp": "211c",
	"./img/icons/like.png": "4116",
	"./img/icons/like.webp": "24fb",
	"./img/icons/lock.svg": "27fa",
	"./img/icons/magic.png": "716a",
	"./img/icons/magic.webp": "c77c",
	"./img/icons/mail.png": "cdd8",
	"./img/icons/mail.webp": "18c0",
	"./img/icons/maps-and-location.png": "c0bd",
	"./img/icons/maps-and-location.webp": "f302",
	"./img/icons/menu.png": "3dc5",
	"./img/icons/menu.webp": "8ba9",
	"./img/icons/money.png": "1ab6",
	"./img/icons/money.webp": "c921",
	"./img/icons/museum.png": "46fe",
	"./img/icons/museum.webp": "34b7",
	"./img/icons/on-time.png": "ab23",
	"./img/icons/on-time.webp": "53b7",
	"./img/icons/online.png": "a48e",
	"./img/icons/online.webp": "27fad",
	"./img/icons/order-status-panel.png": "ccc2",
	"./img/icons/order-status-panel.webp": "4ad1",
	"./img/icons/order.png": "0122",
	"./img/icons/order.webp": "c2f8",
	"./img/icons/passenger.svg": "9d91",
	"./img/icons/payment-compatibility.png": "7ed9",
	"./img/icons/payment-compatibility.webp": "5b4c2",
	"./img/icons/payment-systems.png": "12d3",
	"./img/icons/payment-systems.webp": "ea1c",
	"./img/icons/payment-terminal.png": "cf69",
	"./img/icons/payment-terminal.webp": "aaca",
	"./img/icons/perfume.png": "3faf",
	"./img/icons/perfume.webp": "b6e7",
	"./img/icons/picture-1.png": "73b7",
	"./img/icons/picture-1.webp": "e10c",
	"./img/icons/picture.png": "087a",
	"./img/icons/picture.webp": "2c0b",
	"./img/icons/pin-map.png": "543d",
	"./img/icons/pin-map.webp": "aa0a",
	"./img/icons/pin.png": "b774",
	"./img/icons/pin.webp": "c8ab",
	"./img/icons/point-of-sale.png": "ea9b",
	"./img/icons/point-of-sale.webp": "f224",
	"./img/icons/presentation.png": "f507",
	"./img/icons/presentation.webp": "328d",
	"./img/icons/price-balance.png": "4c73",
	"./img/icons/price-balance.webp": "4668",
	"./img/icons/price-network.png": "8865",
	"./img/icons/price-network.webp": "3edd",
	"./img/icons/price-per-store.png": "92e5",
	"./img/icons/price-per-store.webp": "7b2f",
	"./img/icons/profits.png": "7a35f",
	"./img/icons/profits.webp": "dcbd",
	"./img/icons/purse.png": "3d84",
	"./img/icons/purse.webp": "8bf6",
	"./img/icons/qr-code.png": "9797",
	"./img/icons/qr-code.webp": "5112",
	"./img/icons/question.png": "d517",
	"./img/icons/question.webp": "ca4c",
	"./img/icons/radar.svg": "f53c",
	"./img/icons/receipt-printer.png": "ad3e",
	"./img/icons/receipt-printer.webp": "60a8",
	"./img/icons/refund.png": "71bd",
	"./img/icons/refund.webp": "d18c",
	"./img/icons/report.png": "88c6",
	"./img/icons/report.webp": "eb70",
	"./img/icons/restaurant-alt.png": "d96b",
	"./img/icons/restaurant-alt.webp": "9ed0",
	"./img/icons/restaurant.png": "3550",
	"./img/icons/restaurant.webp": "7eb0",
	"./img/icons/retail.png": "cd6c",
	"./img/icons/retail.webp": "5494",
	"./img/icons/returning-customers.png": "e4c9",
	"./img/icons/returning-customers.webp": "e267",
	"./img/icons/revenu-quebec.svg": "d562",
	"./img/icons/roulette.svg": "e7ea",
	"./img/icons/router.png": "95a9",
	"./img/icons/router.webp": "0889",
	"./img/icons/safety.svg": "7fa8",
	"./img/icons/satellite.png": "180a",
	"./img/icons/satellite.webp": "070f",
	"./img/icons/save-the-world.png": "cec9",
	"./img/icons/save-the-world.webp": "46ce",
	"./img/icons/schedule-online.png": "ab69",
	"./img/icons/schedule-online.webp": "87a7",
	"./img/icons/scholarship.png": "2e1d",
	"./img/icons/scholarship.webp": "6508",
	"./img/icons/school.png": "1f5f",
	"./img/icons/school.webp": "cb59",
	"./img/icons/screen.png": "3587",
	"./img/icons/screen.webp": "3cfb",
	"./img/icons/search.svg": "0930",
	"./img/icons/searching.png": "54b9",
	"./img/icons/searching.webp": "cf07",
	"./img/icons/security-guard.svg": "86e6",
	"./img/icons/send -2.png": "6803",
	"./img/icons/send -2.webp": "b4aa",
	"./img/icons/send.png": "811a",
	"./img/icons/send.webp": "6b6a",
	"./img/icons/server.png": "be14",
	"./img/icons/server.webp": "da20",
	"./img/icons/shield.svg": "3238",
	"./img/icons/shop.png": "c7e7",
	"./img/icons/shop.webp": "10a8",
	"./img/icons/shopping-mall.png": "eb83",
	"./img/icons/shopping-mall.webp": "8ef7",
	"./img/icons/signaling.svg": "8bb5",
	"./img/icons/smartphone-payment.png": "f41a",
	"./img/icons/smartphone-payment.webp": "90b8",
	"./img/icons/store.png": "2132",
	"./img/icons/store.webp": "ca83",
	"./img/icons/streaming-tv-app.png": "ede6",
	"./img/icons/streaming-tv-app.webp": "daf0",
	"./img/icons/survey.png": "765a",
	"./img/icons/survey.webp": "2f627",
	"./img/icons/tablet.png": "4b02",
	"./img/icons/tablet.webp": "1ded",
	"./img/icons/tcby-qr-code.png": "2fa7",
	"./img/icons/tcby-qr-code.webp": "7d12",
	"./img/icons/tea.png": "d580",
	"./img/icons/tea.webp": "d78c",
	"./img/icons/technology.png": "d9f3",
	"./img/icons/technology.webp": "75b7",
	"./img/icons/television.png": "aab8",
	"./img/icons/television.webp": "509b",
	"./img/icons/thumb-up.png": "9097",
	"./img/icons/thumb-up.webp": "0e2e",
	"./img/icons/translate.png": "d386",
	"./img/icons/translate.webp": "a32d",
	"./img/icons/transportation.png": "fbf50",
	"./img/icons/transportation.webp": "d859",
	"./img/icons/tv-order.png": "134d",
	"./img/icons/tv-order.webp": "fc76",
	"./img/icons/tv.png": "7e60",
	"./img/icons/tv.webp": "185f",
	"./img/icons/twitter.png": "9e04",
	"./img/icons/twitter.webp": "b5c4",
	"./img/icons/upload.png": "e75a",
	"./img/icons/upload.webp": "f6b3",
	"./img/icons/videowall.png": "3edc",
	"./img/icons/videowall.webp": "6fb7",
	"./img/icons/wifi.png": "21e2",
	"./img/icons/wifi.webp": "8ef9",
	"./img/icons/worldwide.png": "ba6a",
	"./img/icons/worldwide.webp": "d637",
	"./img/jobs/001-witch.png": "1cdc",
	"./img/jobs/002-wizard.png": "2883",
	"./img/jobs/003-architect.png": "710a",
	"./img/jobs/004-architect.png": "ba19",
	"./img/jobs/005-lawyer.png": "8813",
	"./img/jobs/006-lawyer.png": "5d33",
	"./img/jobs/007-woman.png": "0ebb",
	"./img/jobs/008-man.png": "ce8a",
	"./img/jobs/009-champion.png": "7b86",
	"./img/jobs/010-champion.png": "1176",
	"./img/jobs/011-pilot.png": "039c",
	"./img/jobs/012-pilot.png": "daba",
	"./img/jobs/013-director.png": "06a0",
	"./img/jobs/014-director.png": "e671",
	"./img/jobs/015-composer.png": "c7ef",
	"./img/jobs/016-composer.png": "7704",
	"./img/jobs/017-waiter.png": "19f4",
	"./img/jobs/018-waiter.png": "971c",
	"./img/jobs/019-counselor.png": "3393",
	"./img/jobs/020-counselor.png": "f394",
	"./img/jobs/021-painter.png": "8352",
	"./img/jobs/022-craftsman.png": "3002",
	"./img/jobs/023-Politician.png": "f5a0",
	"./img/jobs/024-Politician.png": "9216",
	"./img/jobs/025-jew.png": "f278",
	"./img/jobs/026-soldier.png": "6907",
	"./img/jobs/027-queen.png": "3e9d",
	"./img/jobs/028-king.png": "0b60",
	"./img/jobs/029-tourist.png": "130c",
	"./img/jobs/030-tourist.png": "18c3",
	"./img/jobs/031-entitled.png": "2d48",
	"./img/jobs/032-entitled.png": "06542",
	"./img/jobs/033-alarm.png": "b649",
	"./img/jobs/034-alarm.png": "c858",
	"./img/jobs/035-executive.png": "bb10",
	"./img/jobs/036-executive.png": "0d32",
	"./img/jobs/037-graphic designer.png": "298b",
	"./img/jobs/038-graphic designer.png": "dd70",
	"./img/jobs/039-hoodie.png": "86d6",
	"./img/jobs/040-hoodie.png": "3288",
	"./img/jobs/041-gift.png": "8f2c",
	"./img/jobs/042-gift.png": "3b9d",
	"./img/jobs/043-haggler.png": "2ba4",
	"./img/jobs/044-haggler.png": "d3b9",
	"./img/jobs/045-student.png": "76c9",
	"./img/jobs/046-student.png": "1e4b",
	"./img/jobs/047-impatient.png": "2de4",
	"./img/jobs/048-impatient.png": "d2ae",
	"./img/jobs/049-indecisive.png": "6fe5",
	"./img/jobs/050-indecisive.png": "5780",
	"./img/jobs/051-doctor.png": "c1c7",
	"./img/jobs/052-doctor.png": "0905",
	"./img/jobs/053-scientist.png": "2885",
	"./img/jobs/054-scientist.png": "53ce",
	"./img/jobs/055-doctor.png": "8977",
	"./img/jobs/056-doctor.png": "bee2",
	"./img/jobs/057-businesswoman.png": "fa33",
	"./img/jobs/058-businessman.png": "98e9",
	"./img/jobs/059-businesswoman.png": "02d3",
	"./img/jobs/060-businessman.png": "baf2",
	"./img/jobs/061-nurse.png": "3e75",
	"./img/jobs/062-nurse.png": "60cd",
	"./img/jobs/063-magician.png": "38be",
	"./img/jobs/064-magician.png": "9fe7",
	"./img/jobs/065-woman.png": "e458",
	"./img/jobs/066-knight.png": "77a1",
	"./img/jobs/067-singer.png": "8e09",
	"./img/jobs/068-singer.png": "1573",
	"./img/jobs/069-sportswoman.png": "5d98",
	"./img/jobs/070-sportsman.png": "066d",
	"./img/jobs/071-woman.png": "1003",
	"./img/jobs/072-man.png": "8457",
	"./img/jobs/073-supervisor.png": "bddc",
	"./img/jobs/074-supervisor.png": "b595",
	"./img/jobs/075-philosopher.png": "24c7",
	"./img/jobs/076-philosopher.png": "88c9",
	"./img/jobs/077-visionary.png": "55ee",
	"./img/jobs/078-visionary.png": "2856",
	"./img/logo.png": "4ffd",
	"./img/markets/construction.jpg": "edd9",
	"./img/markets/construction.webp": "a0da",
	"./img/markets/corporate.jpg": "d630",
	"./img/markets/corporate.webp": "cbc0",
	"./img/markets/education.jpg": "f64b",
	"./img/markets/education.webp": "0f4c",
	"./img/markets/healthcare.jpg": "0423",
	"./img/markets/healthcare.webp": "b6fa",
	"./img/markets/hotels.jpg": "03c4",
	"./img/markets/hotels.webp": "853f",
	"./img/markets/municipalities.jpg": "12bf",
	"./img/markets/municipalities.webp": "f2ea",
	"./img/markets/restauration.jpg": "0885",
	"./img/markets/restauration.webp": "4101",
	"./img/markets/sports.jpg": "469c",
	"./img/markets/sports.webp": "56e4",
	"./img/news/news_hyperlocation_map.png": "f007",
	"./img/news/smart-city.jpg": "2707",
	"./img/office-2.jpg": "9652",
	"./img/office-2.webp": "11d7",
	"./img/office.jpg": "6d58",
	"./img/office.webp": "81ca",
	"./img/partners/eyein-partner-aruba.png": "4d1a",
	"./img/partners/eyein-partner-aruba.webp": "9d2b",
	"./img/partners/eyein-partner-at.png": "9946",
	"./img/partners/eyein-partner-at.webp": "6a0a",
	"./img/partners/eyein-partner-bell.png": "fcfd",
	"./img/partners/eyein-partner-bell.webp": "5faa",
	"./img/partners/eyein-partner-cisco-meraki.png": "f4ba",
	"./img/partners/eyein-partner-cisco-meraki.webp": "64d7",
	"./img/partners/eyein-partner-cisco.png": "ea3f",
	"./img/partners/eyein-partner-cisco.webp": "ab4a",
	"./img/partners/eyein-partner-cogeco.png": "3e4d",
	"./img/partners/eyein-partner-cogeco.webp": "1bde",
	"./img/partners/eyein-partner-dlink.png": "b47d",
	"./img/partners/eyein-partner-dlink.webp": "1f39",
	"./img/partners/eyein-partner-extreme-networks.png": "2ed4",
	"./img/partners/eyein-partner-extreme-networks.webp": "add1",
	"./img/partners/eyein-partner-fortinet.png": "4e0f",
	"./img/partners/eyein-partner-fortinet.webp": "1f94",
	"./img/partners/eyein-partner-lenovo.png": "4818",
	"./img/partners/eyein-partner-lenovo.webp": "e40a",
	"./img/partners/eyein-partner-mikrotik.png": "f2e2",
	"./img/partners/eyein-partner-mikrotik.webp": "4743",
	"./img/partners/eyein-partner-nec.png": "699e",
	"./img/partners/eyein-partner-nec.webp": "5c7b1",
	"./img/partners/eyein-partner-nuclias.png": "24a2",
	"./img/partners/eyein-partner-nuclias.webp": "0d8c",
	"./img/partners/eyein-partner-peplink.png": "4c4e",
	"./img/partners/eyein-partner-peplink.webp": "9959",
	"./img/partners/eyein-partner-rogers.png": "6430",
	"./img/partners/eyein-partner-rogers.webp": "0c6f",
	"./img/partners/eyein-partner-samsung.png": "1ad2",
	"./img/partners/eyein-partner-samsung.webp": "081a",
	"./img/partners/eyein-partner-telus.png": "f3e4",
	"./img/partners/eyein-partner-telus.webp": "b708",
	"./img/partners/eyein-partner-videotron.png": "0e4d",
	"./img/partners/eyein-partner-videotron.webp": "8823",
	"./img/partners/tizen-digital-signage-dark.png": "e4ce",
	"./img/partners/tizen-digital-signage.png": "a5f4",
	"./img/poster.jpg": "1c5c",
	"./img/poster.webp": "f7bb",
	"./img/qr-codes/food-force-tcby-demo.png": "27e7",
	"./img/screenshots/admin-menu-item.png": "872a",
	"./img/screenshots/admin-menu-item.webp": "2b29",
	"./img/screenshots/admin-price-levels.png": "e5fa",
	"./img/screenshots/admin-price-levels.webp": "2ae8",
	"./img/screenshots/admin-tags-assistant.png": "4328",
	"./img/screenshots/admin-tags-assistant.webp": "8e42",
	"./img/screenshots/admin-website.png": "11d5",
	"./img/screenshots/admin-website.webp": "19e3",
	"./img/screenshots/app-choice-assistant.png": "9080",
	"./img/screenshots/app-choice-assistant.webp": "e099",
	"./img/screenshots/app-tcby-menu-25.png": "0e43",
	"./img/screenshots/app-tcby-menu-25.webp": "c674",
	"./img/screenshots/app-tcby-menu.png": "198b",
	"./img/screenshots/bus-journey.png": "4d2c",
	"./img/screenshots/bus-journey.webp": "f5af",
	"./img/screenshots/cmx-annonces.jpg": "0b02",
	"./img/screenshots/cmx-annonces.webp": "99ef",
	"./img/screenshots/cmx-journey.jpg": "da9f",
	"./img/screenshots/cmx-journey.webp": "7a51",
	"./img/screenshots/cmx-overview.png": "77fe",
	"./img/screenshots/cmx-overview.webp": "dd02",
	"./img/screenshots/cmx-profile.jpg": "d5d0",
	"./img/screenshots/cmx-profile.webp": "afc6",
	"./img/screenshots/cmx-stats.jpg": "a941",
	"./img/screenshots/cmx-stats.webp": "f027",
	"./img/screenshots/confetti.png": "ffd2",
	"./img/screenshots/confetti.webp": "57dc",
	"./img/screenshots/daily-menu-scheduler.png": "33f6",
	"./img/screenshots/daily-menu-scheduler.webp": "3a6f",
	"./img/screenshots/delivery-application.png": "50ef",
	"./img/screenshots/delivery-application.webp": "bea2",
	"./img/screenshots/digital-signage.png": "afe3",
	"./img/screenshots/digital-signage.webp": "6cbf",
	"./img/screenshots/example-cafeteria-menu-2-en.jpg": "1016",
	"./img/screenshots/example-cafeteria-menu-2-en.webp": "ce88",
	"./img/screenshots/example-cafeteria-menu-2-fr.jpg": "dc57",
	"./img/screenshots/example-cafeteria-menu-2-fr.webp": "db4f",
	"./img/screenshots/example-cafeteria-menu-en.jpg": "1959",
	"./img/screenshots/example-cafeteria-menu-en.webp": "6cb6",
	"./img/screenshots/example-cafeteria-menu-fr.jpg": "baa5",
	"./img/screenshots/example-cafeteria-menu-fr.webp": "2f8d",
	"./img/screenshots/example-healthcare-code-qr.jpg": "3545",
	"./img/screenshots/example-litterature-contest-qr-code.jpg": "f43c",
	"./img/screenshots/example-litterature-contest-qr-code.webp": "1ad6",
	"./img/screenshots/example-security-healthcare-fr.jpg": "23aa",
	"./img/screenshots/example-security-mri-zone.jpg": "d16c",
	"./img/screenshots/example-sports-results.jpg": "1222",
	"./img/screenshots/example-sports-results.webp": "1476",
	"./img/screenshots/example-teacher-parent-meeting.jpg": "e81a",
	"./img/screenshots/example-teacher-parent-meeting.webp": "dc50",
	"./img/screenshots/eye-in-gdpr-en.png": "2694",
	"./img/screenshots/eye-in-gdpr-en.webp": "a47f",
	"./img/screenshots/eye-intelligence-reports.png": "bffd",
	"./img/screenshots/eye-intelligence-reports.webp": "3bf2",
	"./img/screenshots/filters-fr.png": "0060",
	"./img/screenshots/food-force-main-features.png": "582b",
	"./img/screenshots/food-force-main-features.webp": "4d5a2",
	"./img/screenshots/food-force-reports.png": "2aff",
	"./img/screenshots/food-force-reports.webp": "d384",
	"./img/screenshots/heatmaps.png": "94f7",
	"./img/screenshots/heatmaps.webp": "7a06b",
	"./img/screenshots/kitchen-display.png": "6e06",
	"./img/screenshots/kitchen-display.webp": "0a99",
	"./img/screenshots/menu-fr.png": "1395",
	"./img/screenshots/menuboard-cho-express-small.png": "ec21",
	"./img/screenshots/menuboard-cho-express-small.webp": "284b",
	"./img/screenshots/menuboard-cho-express.png": "de18",
	"./img/screenshots/menuboard-cho-express.webp": "bc5e",
	"./img/screenshots/menuboard-designer.jpg": "3fc2",
	"./img/screenshots/menuboard-designer.webp": "7f43",
	"./img/screenshots/only1-generation-home.png": "56cf",
	"./img/screenshots/only1-generation-home.webp": "90fc",
	"./img/screenshots/order-status-panel.png": "b810",
	"./img/screenshots/order-status-panel.webp": "e572",
	"./img/screenshots/preferences-en.png": "5f37",
	"./img/screenshots/proxy-system.png": "1bc4",
	"./img/screenshots/proxy-system.webp": "de3f",
	"./img/screenshots/recommendations-fr.png": "8db9",
	"./img/screenshots/reserve-shop-reservation.png": "748a",
	"./img/screenshots/reserve-shop-reservation.webp": "004a",
	"./img/screenshots/romanceboard-mccafe-small.png": "c335",
	"./img/screenshots/romanceboard-mccafe.png": "549c",
	"./img/screenshots/romanceboard-mccafe.webp": "64e6",
	"./img/screenshots/starbucks-menu.png": "bafa",
	"./img/screenshots/starbucks-menu.webp": "bd6c",
	"./img/screenshots/starbucks-status-panel-en-small.png": "8877",
	"./img/screenshots/starbucks-status-panel-en-small.webp": "1b14",
	"./img/screenshots/starbucks-status-panel-en.png": "fc68",
	"./img/screenshots/starbucks-status-panel.png": "ad8d",
	"./img/screenshots/starbucks-status-panel.webp": "bf55",
	"./img/screenshots/storyboard_lite.png": "c3a0",
	"./img/screenshots/storyboard_lite.webp": "e37d",
	"./img/screenshots/storyboard_lite_menuboards.png": "a708",
	"./img/screenshots/storyboard_lite_menuboards.webp": "cd3d",
	"./img/screenshots/storyboard_lite_presets.png": "055c",
	"./img/screenshots/storyboard_lite_presets.webp": "7013",
	"./img/screenshots/storyboard_lite_slideshows.png": "f530",
	"./img/screenshots/storyboard_lite_slideshows.webp": "fa94",
	"./img/screenshots/storyboard_lite_widgets.png": "2495",
	"./img/screenshots/storyboard_lite_widgets.webp": "3e68",
	"./img/screenshots/waiter-place-order-mobile.png": "f786",
	"./img/screenshots/waiter-place-order-mobile.webp": "b6c5",
	"./img/screenshots/wayfinder-mobile-ar-view-en.png": "b8da",
	"./img/screenshots/wayfinder-mobile-ar-view-en.webp": "4721",
	"./img/screenshots/wayfinder-mobile-ar-view-fr.png": "2e70",
	"./img/screenshots/wayfinder-mobile-ar-view-fr.webp": "3634",
	"./img/screenshots/wayfinder-mobile-map-en.png": "121d",
	"./img/screenshots/wayfinder-mobile-map-en.webp": "2873",
	"./img/screenshots/wayfinder-mobile-map-fr.png": "c6f4b",
	"./img/screenshots/wayfinder-mobile-map-fr.webp": "50b5",
	"./img/store/product-commercial-tv.jpg": "cb3e",
	"./img/store/product-digital-signage-license.jpg": "6221",
	"./img/store/product-digital-signage-software.jpg": "f1ec",
	"./img/store/product-kiosk.jpg": "5e8a",
	"./img/store/product-packages.jpg": "78b0",
	"./img/store/product-tizen-complete-package-with-arrows.jpg": "f3ab",
	"./img/store/product-touch-screen-tv.jpg": "142f",
	"./img/store/service-custom-design.jpg": "3203",
	"./img/store/service-premium-support.jpg": "cf4f",
	"./img/video-splash/customer-journey.jpg": "618a",
	"./img/video-splash/customer-journey.webp": "1126",
	"./img/video-splash/intro-en.jpg": "f6a0",
	"./img/video-splash/intro-fr.jpg": "3b3d",
	"./img/video-splash/intro-mobile-en.jpg": "28d7",
	"./img/video-splash/intro-mobile-fr.jpg": "7128",
	"./img/video-splash/mc-donald-thumbnail-small.png": "9dbd",
	"./img/video-splash/mc-donald-thumbnail.jpg": "16c2",
	"./img/video-splash/menu-cho-express-thumbnail.jpg": "fd14",
	"./img/video-splash/menu-creation-thumbnail-small.png": "4f0c",
	"./img/video-splash/menu-creation-thumbnail.jpg": "2657",
	"./img/video-splash/menu-thai-express-thumbnail.jpg": "aebf",
	"./img/video-splash/overview-mc-donald.jpg": "613d",
	"./img/video-splash/overview-mc-donald.webp": "f6b0",
	"./img/video-splash/storyboard-pro-creation.jpg": "f4a1",
	"./img/video-splash/storyboard-pro-creation.webp": "7486",
	"./img/video-splash/upload-email-generic-en.png": "9c08",
	"./img/video-splash/upload-email-generic-en.webp": "2895",
	"./img/video-splash/upload-email-generic-fr.png": "de94",
	"./img/video-splash/upload-email-generic-fr.webp": "3376",
	"./img/video-splash/virtual-assistant-lakeshore-splash.jpg": "72b8",
	"./img/video-splash/virtual-assistant-lakeshore-splash.webp": "6be6",
	"./style/bootstrap-theme.scss": "5abd",
	"./style/buttons.scss": "16b9e",
	"./style/cards.scss": "ca2f",
	"./style/carousels.scss": "9cd3",
	"./style/chrome.scss": "89b2",
	"./style/cursors.scss": "ab4a7",
	"./style/forms.scss": "f7b0",
	"./style/global.scss": "2d3f",
	"./style/gradients.scss": "3231",
	"./style/layout.scss": "55ad",
	"./style/modals.scss": "09a1",
	"./style/tabs.scss": "765c",
	"./style/texts.scss": "9ff8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";